import React, { useState } from "react";
import { ShieldAlert, ScanSearch, Zap, FileCheck2, ArrowRight } from "lucide-react";
import { SCENARIOS } from "../../data/content";

const toneStyles = {
  block: { chip: "bg-signal-red/15 text-signal-red border-signal-red/30", label: "Blocked" },
  escalate: { chip: "bg-signal-amber/15 text-signal-amber border-signal-amber/30", label: "Escalated" },
  redact: { chip: "bg-primary/15 text-primary border-primary/30", label: "Redacted" },
};

const stages = [
  { key: "event", label: "Event", icon: ShieldAlert },
  { key: "detection", label: "Detection", icon: ScanSearch },
  { key: "action", label: "Action", icon: Zap },
  { key: "outcome", label: "Outcome", icon: FileCheck2 },
];

export default function InteractionDemo() {
  const [active, setActive] = useState(SCENARIOS[0].id);
  const scenario = SCENARIOS.find((s) => s.id === active);
  const tone = toneStyles[scenario.tone];

  return (
    <div className="rounded-lg border border-white/10 bg-navy-900/60 overflow-hidden">
      <div className="flex flex-wrap gap-2 p-4 border-b border-white/10">
        {SCENARIOS.map((s) => (
          <button
            key={s.id}
            onClick={() => setActive(s.id)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors border ${
              active === s.id
                ? "bg-primary/12 border-primary/40 text-foreground"
                : "border-white/10 text-muted-foreground hover:text-foreground hover:bg-white/5"
            }`}
          >
            {s.tab}
          </button>
        ))}
      </div>

      <div className="p-5 sm:p-7">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <span className="text-xs uppercase tracking-[0.14em] text-muted-foreground">
            {scenario.direction}
          </span>
          <span className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold ${tone.chip}`}>
            {tone.label}
          </span>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {stages.map((st, i) => {
            const Icon = st.icon;
            return (
              <div key={st.key} className="relative rounded-xl border border-white/10 bg-white/[0.02] p-4">
                <div className="flex items-center gap-2">
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-primary/12 text-primary">
                    <Icon className="h-4 w-4" />
                  </span>
                  <span className="text-sm font-semibold text-foreground">{st.label}</span>
                </div>
                <p className="mt-3 text-sm text-muted-foreground leading-relaxed">{scenario[st.key]}</p>
                {i < stages.length - 1 && (
                  <ArrowRight className="hidden lg:block absolute -right-[11px] top-1/2 -translate-y-1/2 h-4 w-4 text-primary/50 z-10" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
